<template>
    <div>
        <design-2021-apprentice-video-player-component :options="playerOptions">
        </design-2021-apprentice-video-player-component>
        <div class="video-download">
            <div class="icon btn-video-icon"></div>
            <div class="title">
                {{ video.name }}
                <div class="file-size text-muted">
                    {{ video.size }}
                </div>
            </div>
            <div class="file-download">
                <b-button
                    class="btn-download btn-file-download"
                    variant="primary-icon-only"
                    :href="video.path"
                    target="_blank"></b-button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            video: Object,
        },
        name: 'design-2021-quest-mission-user-review-video-component',
        data() {
            return {
                playerOptions: {
                    autoplay: false,
                    controls: true,
                    sources: [
                        {
                            src: this.video.path,
                            type: 'video/' + this.video.extension,
                        },
                    ],
                },
            };
        },
    };
</script>

<style scoped lang="scss">
    .video-download {
        display: flex;
        justify-content: flex-start;
        align-content: center;
        font-size: 1.3125rem;

        .icon {
            align-self: flex-start;
            padding: map-get($grid-gutter-spacing, 'ten');
            background: $secondary-background-color;
            border-radius: $border-radius-content;
            color: var(--primary);

            &:before {
                margin-right: 0;
            }
        }

        .title {
            font-size: $default-font-size;
            font-weight: $font-weight-bold;
            margin-left: map-get($grid-gutter-spacing, 'fifteen');
            margin-right: map-get($grid-gutter-spacing, 'fifteen');
            align-self: center;
            word-break: break-word;
        }

        .file-download {
            display: flex;
            align-items: center;
            align-self: flex-start;
            margin-left: auto;
        }
    }

    @media (min-width: map-get($grid-breakpoints, 'sm')) {
    }
</style>
